import { HTTP_INTERCEPTORS } from "@angular/common/http";
import AuthInterceptorService from "./authInterceptor.service";
import CacheBustInterceptorService from "./cacheBustInterceptor.service";
import ErrorInterceptorService from "./errorInterceptor.service";
import { BlockRequestsInterceptor } from "./blockRequestsInterceptor.service";

export const interceptorProviders = [
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CacheBustInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: BlockRequestsInterceptor, multi: true },
];
